import type { NewsArticle } from '@/types';

export const newsCategories = ['全部', '影评', '业内动态', '奖项', '预告片', '票房'];

export const newsList: NewsArticle[] = [
  {
    id: '1',
    title: '《星际隧道》口碑爆棚：这可能是近十年最好的科幻片',
    subtitle: '穿越虫洞的浪漫与哲思，重新定义了大银幕上的宇宙',
    category: '影评',
    date: '2026-10-12',
    author: '影评人·夜色',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20glowing%20wormhole%20tunnel%20in%20deep%20space%2C%20moody%20midnight-blue%20and%20dark%20charcoal%20tones%20with%20warm%20orange%20glow%2C%20film%20grain%2C%20elegant%20magazine%20layout%20feeling%2C%20high%20detail%2C%20atmospheric&width=800&height=500&seq=news-cover-01&orientation=landscape',
    excerpt:
      '《星际隧道》用一场跨越星系的远征，讲述了人类对未知的渴望与对家的眷恋。视觉奇观之外，影片最动人的，是那份藏在宇宙尺度下的细腻情感。',
    content: [
      '当《星际隧道》的片头音乐第一次响起，整个影厅瞬间安静下来。导演用近乎虔诚的镜头语言，把观众带进了一个既浩瀚又温柔的宇宙。这不是一部靠爆炸和特效堆砌的科幻片，而是一封写给人类勇气的情书。',
      '影片的核心，是那支穿越虫洞的远征队。他们中的每一个人，都带着各自的遗憾与牵挂出发。当时间的尺度被无限拉长，个人的悲欢显得如此渺小，可正是这些渺小的情感，支撑着他们走完了整段旅程。',
      '在视觉层面，影片对虫洞与深空的呈现堪称惊艳。那种介于真实与想象之间的光影，让观众几乎能感受到宇宙的呼吸。而橙色与深蓝的色调碰撞，也成为了整部电影最令人难忘的视觉记忆。',
      '当然，影片并非完美无缺。中段的节奏略显舒缓，部分科学设定也引来了一些讨论。但瑕不掩瑜，当最后一个镜头定格，你很难不被那种宏大的温柔所打动。',
      '如果你正在寻找一部能在散场后久久回味、并与身边人讨论一整晚的电影，《星际隧道》值得走进影院。',
    ],
  },
  {
    id: '2',
    title: '第98届奥斯卡提名公布，《星海征途》领跑全场',
    subtitle: '科幻与人文的交锋，本届奖项竞争空前激烈',
    category: '奖项',
    date: '2026-10-08',
    author: '特约记者·林一',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20prestigious%20golden%20film%20award%20statue%20on%20a%20dark%20stage%20with%20spotlight%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20glow%2C%20film%20grain%2C%20high%20detail%2C%20award%20ceremony%20atmosphere&width=800&height=500&seq=news-cover-02&orientation=landscape',
    excerpt:
      '本届奥斯卡提名名单正式揭晓，《星海征途》以十一项提名领跑，成为最大热门。与此同时，多部小成本文艺片也收获了重要提名，竞争异常激烈。',
    content: [
      '经过数月的猜测与期待，第98届奥斯卡金像奖提名名单终于公布。科幻史诗《星海征途》一举拿下包括最佳影片、最佳导演在内的十一项提名，成为本届最大赢家。',
      '评委会对这部影片的评价集中在“宏大的视野”与“细腻的情感”两点上。有评委表示，《星海征途》让科幻类型电影再次回到了颁奖季的中心位置。',
      '不过，竞争远未结束。多部小成本文艺片同样表现出色，《山那边的家》与《最后一班地铁》分别入围多项重要奖项，被认为是最有可能制造惊喜的黑马。',
      '技术类奖项方面，《星际隧道》与《深海回声》在视觉效果与音效领域的对决同样值得期待。业内人士普遍认为，今年的技术奖项悬念甚至超过表演奖项。',
      '颁奖典礼将于明年三月举行，让我们共同期待这场属于电影人的年度盛会。',
    ],
  },
  {
    id: '3',
    title: '《深海回声》发布终极预告：海底之下藏着什么',
    subtitle: '短短两分钟的预告，让无数观众直呼“后背发凉”',
    category: '预告片',
    date: '2026-10-05',
    author: '资讯组·小鹿',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20deep%20sea%20submarine%20in%20dark%20abyssal%20water%20with%20glowing%20bioluminescent%20creatures%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20mysterious%20atmosphere&width=800&height=500&seq=news-cover-03&orientation=landscape',
    excerpt:
      '即将上映的深海悬疑片《深海回声》发布了终极预告，短短两分钟的画面里，压抑的氛围与无法捉摸的未知，让观众对海底的秘密充满好奇。',
    content: [
      '《深海回声》的终极预告片在上线后迅速刷屏。与之前的先行预告相比，这一版更加克制，却也更让人不寒而栗。',
      '预告片中，深海科考队的潜艇在无光的海沟中缓缓下沉，声呐屏幕上突然出现的未知信号，成为了整段预告的核心悬念。',
      '导演在采访中透露，影片的一大特色在于“真实感”——大部分水下场景都采用了实景与物理特效结合的方式拍摄，希望能让观众身临其境地感受深海的压迫感。',
      '作为本年度最受期待的悬疑片之一，《深海回声》将于下月正式与观众见面，届时深海之下究竟藏着什么，也将揭晓答案。',
      '喜欢悬疑与惊悚题材的观众，不妨提前关注这部作品。',
    ],
  },
  {
    id: '4',
    title: '国庆档票房创历史新高：国产电影迎来黄金时代',
    subtitle: '多部类型片齐发力，观众观影热情持续高涨',
    category: '票房',
    date: '2026-10-02',
    author: '数据组·阿榜',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20crowded%20modern%20cinema%20lobby%20with%20warm%20glowing%20lights%20and%20movie%20posters%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20festive%20atmosphere&width=800&height=500&seq=news-cover-04&orientation=landscape',
    excerpt:
      '本次国庆档总票房再创新高，多部国产类型片表现亮眼。观众日益成熟的观影口味，正在推动中国电影市场走向更高质量的发展阶段。',
    content: [
      '根据最新统计数据，本次国庆档期总票房刷新历史纪录，观影人次较去年同期大幅增长。这一成绩，标志着国产电影市场正在稳步复苏并持续向好。',
      '从影片类型来看，动作、科幻、喜剧多线开花，观众的选择更加多元。其中，《暗夜追凶》与《疯狂周末》分别在不同观众群体中取得了优异的口碑与票房表现。',
      '业内人士分析，票房的增长不仅来自于档期效应，更源于影片本身质量的提升。越来越多创作者开始专注于讲好故事，而不是单纯依赖营销。',
      '与此同时，影院的观影体验也在不断升级，IMAX、杜比影院等高规格影厅的上座率明显提高，反映出观众对高品质观影的追求。',
      '可以说，国产电影正在迎来属于自己的黄金时代，而观众，正是这场繁荣最大的受益者。',
    ],
  },
  {
    id: '5',
    title: '《山那边的家》深度解析：一碗饭里的中国式亲情',
    subtitle: '没有激烈的冲突，却让无数观众泪洒影院',
    category: '影评',
    date: '2026-09-28',
    author: '影评人·禾木',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20terraced%20green%20mountains%20at%20dawn%20with%20morning%20mist%20and%20a%20small%20house%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20peaceful%20atmosphere&width=800&height=500&seq=news-cover-05&orientation=landscape',
    excerpt:
      '《山那边的家》用最朴素的镜头，讲述了一个关于陪伴与告别的故事。它没有刻意的煽情，却让每一个有过相似经历的人，在银幕前红了眼眶。',
    content: [
      '在众多追求视效奇观的大片之中，《山那边的家》显得格外安静。它把镜头对准了山里的老屋、田间的劳作，以及一家人围坐吃饭的日常。',
      '影片最打动人的，是那些看似平淡的细节：母亲往女儿碗里夹菜的手、父亲默默修好的旧自行车、夜里为家人留着的一盏灯。这些画面没有一句台词，却胜过千言万语。',
      '导演在采访中表示，他希望用这部电影记录下那些正在消失的乡村生活，以及中国人表达爱意的独特方式——不擅言辞，却把一切都藏在行动里。',
      '当然，也有观众认为影片节奏偏慢。但正是这种缓慢，让情感得以一点点沉淀，最终在结尾处汇聚成难以抑制的感动。',
      '这是一部适合带着家人一起观看的电影，也是一次关于“回家”的温柔提醒。',
    ],
  },
  {
    id: '6',
    title: '《幻境之城》幕后揭秘：每一帧都是壁纸是怎样炼成的',
    subtitle: '从手绘分镜到最终渲染，动画团队耗时四年打磨',
    category: '业内动态',
    date: '2026-09-22',
    author: '资讯组·小鹿',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20floating%20surreal%20city%20with%20waterfalls%20and%20thousands%20of%20glowing%20lanterns%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20dreamy%20atmosphere&width=800&height=500&seq=news-cover-06&orientation=landscape',
    excerpt:
      '动画电影《幻境之城》凭借唯美的画面征服了观众。今天，让我们走进幕后，看看这座漂浮的幻想之城，究竟是如何被一帧一帧创造出来的。',
    content: [
      '《幻境之城》上映后，关于其画面的讨论从未停止。许多观众表示，电影里的每一帧都可以直接截下来当壁纸，而这背后，是团队长达四年的坚持。',
      '据制作团队介绍，影片最初的分镜全部由手绘完成，仅核心场景就绘制了上千张草图。为了呈现出漂浮城市的光影层次，美术团队反复调试了数百次配色方案。',
      '在技术层面，团队开发了一套独创的灯光渲染流程，让画面在保有动画质感的同时，又具备电影级的写实质感。那一盏盏永不熄灭的灯火，正是这套技术的结晶。',
      '音乐同样是影片的一大亮点。作曲家花了近一年时间采风，将传统乐器与现代编曲融合，为这座幻境之城注入了独特的灵魂。',
      '可以说，《幻境之城》的成功，是无数个日夜打磨的结果。它让我们相信，用心做出来的作品，观众一定能感受到。',
    ],
  },
  {
    id: '7',
    title: '悬疑片为何越来越受欢迎？从《迷雾之城》说起',
    subtitle: '当观众厌倦了套路，真正的谜题才刚刚开始',
    category: '业内动态',
    date: '2026-09-18',
    author: '特约记者·林一',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20foggy%20city%20skyline%20at%20night%20with%20glowing%20lights%20and%20a%20lone%20figure%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20mysterious%20atmosphere&width=800&height=500&seq=news-cover-07&orientation=landscape',
    excerpt:
      '近年来，悬疑类型片在市场上持续走热。观众究竟在追寻什么？《迷雾之城》等作品的成功，或许能为我们提供一些答案。',
    content: [
      '如果你留意近几年的片单，会发现悬疑片的数量明显增加。从院线大片到网络剧集，这种曾经小众的类型，正逐渐成为主流的观影选择。',
      '以《迷雾之城》为例，它之所以能获得口碑与票房的双丰收，靠的并不是复杂的诡计，而是对人性幽微之处的深刻洞察。观众在解谜的同时，也在审视自己。',
      '有分析认为，悬疑片之所以受欢迎，是因为它提供了一种“参与感”。观众不再是单纯的信息接收者，而是可以跟着主角一起推理、一起推翻、一起接近真相。',
      '此外，悬疑片往往成本可控，题材灵活，非常适合创作者发挥创意。这也吸引了一大批有想法的年轻导演投身其中。',
      '当然，套路化的问题依然存在。如何在类型框架内讲出新意，将是悬疑片创作者们需要持续思考的课题。',
    ],
  },
  {
    id: '8',
    title: '《星际隧道》主创专访：我们想拍一部温柔的电影',
    subtitle: '导演与主演畅聊拍摄幕后，揭秘那些不为人知的细节',
    category: '业内动态',
    date: '2026-09-12',
    author: '资讯组·小鹿',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20film%20director%20chair%20and%20camera%20on%20a%20dark%20studio%20set%20with%20warm%20accent%20lights%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20behind%20the%20scenes&width=800&height=500&seq=news-cover-08&orientation=landscape',
    excerpt:
      '在《星际隧道》热映之际，我们与影片导演及主演进行了一次深入对谈，聊聊这部科幻巨制背后的创作理念与情感内核。',
    content: [
      '“我们一开始就没打算拍一部冷冰冰的科幻片。”导演在采访中说，“我想拍的是人，是人在宇宙面前的那份渺小与倔强。”',
      '为了呈现真实的太空质感，剧组搭建了多个等比例实景模型，并邀请航天专家担任顾问。主演透露，有一段戏他在失重舱里连续拍摄了十四个小时。',
      '谈到影片中最受好评的情感线，主演表示，最难的地方在于“克制”。“你明明很想哭，但角色不能哭，他必须把所有的思念都咽下去，继续往前。”',
      '导演还分享了选角的过程：“我们需要的是那种眼神里有故事的人。技术可以打磨，但那种东西是装不出来的。”',
      '当被问到是否会有续集，导演卖了个关子：“宇宙很大，故事还远远没有讲完。”',
    ],
  },
  {
    id: '9',
    title: '《铁血战士》重映：一部战争片为何能常看常新',
    subtitle: '十年之后再回溯，我们依然被那份沉重所震撼',
    category: '影评',
    date: '2026-09-06',
    author: '影评人·夜色',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20ruined%20smoking%20warzone%20at%20dawn%20with%20distant%20silhouettes%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20somber%20atmosphere&width=800&height=500&seq=news-cover-09&orientation=landscape',
    excerpt:
      '时隔多年，《铁血战士》以修复版重回大银幕。再次观看，它依然能让人在片尾长久沉默——这或许就是经典战争片的力量。',
    content: [
      '《铁血战士》最令人敬畏的地方，不在于它拍出了多宏大的战争场面，而在于它始终把镜头对准了战争中的“人”。',
      '重看这部影片，那些关于恐惧、责任与抉择的片段依然令人动容。尤其是一次次面对命令与良心冲突时，主人公的挣扎被刻画得格外真实。',
      '修复版在画质与音效上做了全面提升，那些原本模糊的战场细节得以清晰呈现，反而让影片的沉重感更加立体。',
      '有观众在观影结束后说：“这不是一部让人想鼓掌的电影，而是一部让人想安静坐一会儿的电影。”这句话，或许是对它最好的评价。',
      '如果你还没有看过《铁血战士》，这次的修复重映，是一个不错的开始。',
    ],
  },
  {
    id: '10',
    title: '秋冬档前瞻：这十部新片值得你买票进影院',
    subtitle: '从科幻史诗到温情小品，总有一部适合你',
    category: '业内动态',
    date: '2026-09-01',
    author: '资讯组·小鹿',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20modern%20cinema%20screen%20glowing%20in%20a%20dark%20auditorium%20with%20warm%20orange%20seats%2C%20midnight-blue%20and%20charcoal%20tones%20with%20warm%20orange%20accent%2C%20film%20grain%2C%20high%20detail%2C%20inviting%20atmosphere&width=800&height=500&seq=news-cover-10&orientation=landscape',
    excerpt:
      '随着秋冬档期临近，一大批备受期待的新片即将上映。我们为你精选了十部不容错过的作品，涵盖多种类型，总有一部会打动你。',
    content: [
      '每到年末，影市总会迎来一年中最热闹的时段。今年也不例外，多部重磅作品已经定档，准备在接下来的几个月里与观众见面。',
      '从片单来看，科幻与悬疑依然是主力。《星海征途》《幻境之城》等作品凭借精良的制作备受期待，而《追风少年》等现实题材同样引人关注。',
      '此外，多部适合全家观看的温情喜剧也将在年末登陆院线，为节日氛围增添一份欢乐。',
      '业内人士提醒，热门影片的黄金时段往往一票难求，建议观众提前关注排片并合理规划观影时间。',
      '无论你偏爱哪种类型，这个秋冬档，都值得你走进影院，感受大银幕独有的魅力。',
    ],
  },
];